var WooNavigation = {

	isMobile:false,

	init:function(){
		$(window).resize(function(){
			WooNavigation.resize();
		});
		WooNavigation.resize();

		$(".my-account-navigation").on("click touchend", function(e){

			Debug.log("CLICK NAVIGATION");
			if(e.type == 'touchend'){
				$(this).off("click");
			}

			if(WooNavigation.isMobile == true){

				setTimeout(function(){
					$(".my-account-navigation").toggleClass("open");	
				}, 100);

			}
		})

	},
	resize:function(){
		if($(".my-account-navigation .arrow").css("display") == "none"){
			$(".my-account-navigation").removeClass("open");
			WooNavigation.isMobile = false;
		}else{
			$(".my-account-navigation").removeClass("open");
			WooNavigation.isMobile = true;
		}
	},
	open_navigation:function(){

	},
	close_navigation:function(){

	}

}

$(window).load(function(){
	if($(".my-account-navigation").length){
		WooNavigation.init();
	}
})